var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, Injector } from '@angular/core';
import { AppConfigurationLookupServiceProxy } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConfigurationService } from '@app/shared/services/appconfigration.service';
var CarrierMultiSelectComponent = /** @class */ (function (_super) {
    __extends(CarrierMultiSelectComponent, _super);
    function CarrierMultiSelectComponent(injector, _appConfigurationService, _appConfigurationLookupService) {
        var _this = _super.call(this, injector) || this;
        _this._appConfigurationService = _appConfigurationService;
        _this._appConfigurationLookupService = _appConfigurationLookupService;
        _this.depotIds = [];
        _this.name = 'CarrierCodeFilter';
        _this.selectedItemsChange = new EventEmitter();
        _this.placeholder = _this.l('CarrierCode');
        _this.options = new Array();
        _this._selectedItems = [];
        return _this;
    }
    Object.defineProperty(CarrierMultiSelectComponent.prototype, "selectedItems", {
        get: function () {
            return this._selectedItems;
        },
        set: function (file) {
            this._selectedItems = file || [];
            this.selectedItemsChange.emit(this._selectedItems);
        },
        enumerable: true,
        configurable: true
    });
    ;
    CarrierMultiSelectComponent.prototype.ngOnInit = function () {
        this.getCarriers();
    };
    CarrierMultiSelectComponent.prototype.getCarriers = function () {
        var _this = this;
        if (!!this.isDriver || !!this.hasD365Entity || this.depotIds.length > 0) {
            this._appConfigurationLookupService.getCarriers('', this.depotIds, this.isDriver, this.hasD365Entity)
                .subscribe(function (carriers) { return _this.options = carriers; });
        }
        else {
            this._appConfigurationService.getCarriers().subscribe(function (carriers) { return _this.options = carriers; });
        }
    };
    CarrierMultiSelectComponent.prototype.onPanelHide = function () {
        document.getElementById(this.name).focus();
    };
    return CarrierMultiSelectComponent;
}(AppComponentBase));
export { CarrierMultiSelectComponent };
